<template>
  <VListItem
    key="logout"
    :class="{'close' : miniVariant}"
    @click="logout"
  >
    <VListItemContent class="d-block">
      <VListItemTitle
        :class="miniVariant
          ? 'd-block' : 'd-flex align-center flex-row justify-start flex-nowrap'"
      >
        <div class="menu-icon">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1099_718)">
              <path d="M2.75 2.75H7.33333V0H2.75C2.02065 0 1.32118 0.289731 0.805456 0.805456C0.289731 1.32118 0 2.02065 0 2.75L0 19.25C0 19.9793 0.289731 20.6788 0.805456 21.1945C1.32118 21.7103 2.02065 22 2.75 22H7.33333V19.25H2.75V2.75Z" fill="white" />
              <path d="M21.0357 8.73124L16.8318 4.5274L14.8876 6.47257L18.0161 9.60024L4.58331 9.62499V12.375L18.0583 12.3502L14.8811 15.5274L16.8254 17.4726L21.0301 13.2687C21.6313 12.6671 21.9694 11.8516 21.9704 11.0011C21.9715 10.1506 21.6353 9.33437 21.0357 8.73124Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1099_718">
                <rect width="22" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        {{ $t('logout') }}
      </VListItemTitle>
    </VListItemContent>
  </VListItem>
</template>

<script>
export default {
  name: 'TheMenuLogout',
  props: {
    miniVariant: Boolean,
  },
  methods: {
    async logout() {
      await this.$router.push({ name: 'logout' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-list-item {
    &::after {
      display: none;
    }
  }

  .v-list-item__content::v-deep {
    padding: 10px !important;
    @media screen and (max-width: 1650px) {
      padding: 5px !important;
    }
    @media screen and (max-width: 600px) {
      padding: 3px 12px 3px 12px !important;
    }
    @media screen and (max-width: 320px) {
      padding: 0px 7px 0px 7px !important;
    }

    .v-list-item__title {
      @media screen and (max-width: 599px) {
        font-weight: 600;
        font-size: 20px !important;
        line-height: 100%;
      }
      @media screen and (max-width: 320px) {
        font-size: 16px !important;
      }
      .menu-icon {
        @media screen and (max-width: 599px) {
          width: 18px;
        }
      }
    }
  }
</style>

<i18n locale="ru" lang="yaml">
  logout: Выйти
</i18n>

<i18n locale="en" lang="yaml">
  logout: Logout
</i18n>
